import { IllegalArgumentError } from 'faro-common-model';
import { z } from 'zod';
import { uuidish } from '../../utils/uuidish.js';
import { nullishToUndefined } from '../../utils/nullishToUndefined.js';
export const auditEventTypeSchema = z.enum(['study-designer-export']);
export const auditEventSchema = z.object({
    id: uuidish,
    type: auditEventTypeSchema,
    created: z.date().nullish().transform(nullishToUndefined).optional(),
    body: z.unknown(),
});
export function toAuditEvent(auditEvent) {
    const result = auditEventSchema.safeParse(auditEvent);
    if (!result.success) {
        throw new IllegalArgumentError(`Invalid AuditEvent object. ${result.error.message}`);
    }
    return result.data;
}
//# sourceMappingURL=audit-event.js.map